/* Producción urgente · Imprimirlo
 *
 * Aquí no se vende una camiseta, se vende una FECHA. El cliente que va tarde
 * no compara precios: comprueba si llegas. Por eso es lo que más margen
 * aguanta de toda la ficha — y también lo que más daño hace si se promete y
 * no se cumple.
 *
 * Va en su propio fichero a propósito: las reglas de qué se puede prometer
 * cambian cada dos por tres (el tope, la hora, los colores) y así se tocan sin
 * mover el configurador entero.
 *
 * TODAS las reglas están en la configuración de la ficha, en ropa.liquid:
 *
 *   bandas   el precio por TRAMOS de cantidad, uno por variante del producto.
 *            No es plano. Por coste casi lo sería —romper el lote y montar
 *            mesa fuera de turno pasa una vez, pidas 1 o 10—, pero por valor
 *            no: el que necesita 10 camisetas para mañana tiene un evento
 *            detrás, y el que necesita una, un regalo. Cobrar lo mismo dejaba
 *            la urgencia en un +115 % sobre una camiseta suelta y en 1,50 €
 *            por prenda en un pedido de diez.
 *   tope     máximo de prendas. Por encima no da tiempo en el día.
 *   corte    hora límite para que salga hoy, en formato 24 h.
 *   colores  colores que se pueden prometer. Solo los que hay siempre en
 *            estantería: si hay que pedirlo al proveedor, no es urgente.
 *            Lista vacía = cualquier color.
 */
(function () {
  'use strict';

  function money(c) {
    return (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  // el tramo de precio que le toca a esta cantidad
  function banda(cfg, uds) {
    var bs = (cfg && cfg.bandas) || [];
    for (var i = 0; i < bs.length; i++) {
      if (uds >= bs[i].desde && (bs[i].hasta == null || uds <= bs[i].hasta)) return bs[i];
    }
    return null;
  }

  /* Tope de unidades. Con `topeBlanco` (tazas, Xavi 02/10): hasta topeBlanco si TODAS son de los colores de `blancos`, y hasta `tope` si hay
     alguna de color. Sin él, el tope normal. */
  function limite(cfg, colores) {
    if (cfg && cfg.topeBlanco != null) {
      var bl = cfg.blancos || [], todas = (colores || []).length > 0 && (colores || []).every(function (c) { return bl.indexOf(c) !== -1; });
      return todas ? cfg.topeBlanco : (cfg.tope || 5);
    }
    return (cfg && cfg.tope) || 10;
  }

  /* ¿Se puede prometer este pedido para mañana?
     Devuelve null si sí, y si no el MOTIVO, que sirve para decidir si se
     calla la casilla o se explica por qué no está. */
  function estorbo(cfg, uds, colores) {
    if (!cfg || !(cfg.bandas || []).length) return 'sin-producto';
    if (!uds) return 'sin-prendas';
    if (uds > limite(cfg, colores)) return 'demasiadas';
    if (!banda(cfg, uds)) return 'sin-producto';

    var ok = cfg.colores || [];
    if (ok.length) {
      var fuera = (colores || []).filter(function (c) { return ok.indexOf(c) === -1; });
      if (fuera.length) return 'color';
    }

    /* La hora sale del reloj del cliente. No es exacta si lo tiene mal puesto,
       pero el pedido lo revisa Xavi igual y es mil veces mejor que no ofrecer
       nada. Fines de semana no: no hay taller. */
    var ahora = new Date(), dia = ahora.getDay();
    if (dia === 0 || dia === 6) return 'finde';
    if (ahora.getHours() >= (cfg.corte != null ? cfg.corte : 14)) return 'tarde';
    return null;
  }

  function cabe(cfg, uds, colores) { return estorbo(cfg, uds, colores) === null; }

  /* Pinta la casilla, o la quita. Devuelve si sigue en pie, para que quien
     llame sepa si tiene que desmarcarla. */
  function pintar(caja, cfg, uds, colores, puesto) {
    if (!caja) return false;
    var motivo = estorbo(cfg, uds, colores);
    if (motivo) {
      /* Cuando no cabe por CANTIDAD o por COLOR se dice por qué: el cliente
         que pide 15 camisetas urgentes prefiere saber que a partir de 10 no
         llegamos, y a lo mejor pide 10. Callarse ahí es perder la venta.
         Por hora o por fin de semana no se dice nada: enseñar "hoy ya no
         llegas" justo antes del botón solo sirve para que se lo piense. */
      // con `silencio` (taza) no se explica por qué no cabe: la caja desaparece
      var texto = cfg.silencio ? '' : motivo === 'demasiadas'
        ? (cfg.topeBlanco != null
            ? 'La entrega en 24 h es para pedidos de hasta ' + cfg.topeBlanco + ' tazas blancas o ' + (cfg.tope || 5) + ' de color.'
            : 'La entrega en 24 h es para pedidos de hasta ' + (cfg.tope || 10) + ' prendas.')
        : motivo === 'color'
        ? 'La entrega en 24 h solo la podemos garantizar en ' +
          (cfg.colores || []).join(' y ') + '.'
        : '';
      caja.innerHTML = texto ? '<p class="rop-urg__no">' + texto + '</p>' : '';
      caja.classList.remove('is-puesta');
      caja.hidden = !texto;
      caja.dataset.hecho = '';
      return false;
    }
    /* El precio cambia con la cantidad, así que la caja se vuelve a pintar
       cuando cambia de tramo — si no, se quedaría el precio del tramo viejo. */
    var b = banda(cfg, uds);
    if (caja.dataset.hecho !== String(b.desde)) {
      caja.innerHTML = '<label class="rop-urg"><input type="checkbox" data-urg>' +
        '<span><b>Lo necesito para mañana</b> · ' + money(b.precio) + '<br>' +
        '<span class="rop-muted">Lo produzco hoy mismo y sale con servicio ' +
        'garantizado de 24 h. Pídelo antes de las ' +
        (cfg.corte != null ? cfg.corte : 14) + ':00.</span></span></label>';
      caja.dataset.hecho = String(b.desde);
    }
    var c = caja.querySelector('[data-urg]');
    if (c) c.checked = !!puesto;
    caja.classList.toggle('is-puesta', !!puesto);
    caja.hidden = false;
    return true;
  }

  window.Urgente = { cabe: cabe, estorbo: estorbo, pintar: pintar, banda: banda };
})();